import React, { useContext, useEffect, useRef } from "react";
import "../assets/css/Homepage.css";
import Events from "./Events";
import webinarContext from "../context/webinarContext";
import UpComingEvents from "./UpComingEvents";
import { useLocation } from "react-router-dom";

function Homepage() {
  const context = useContext(webinarContext);
  const { webinars } = context;
  const { state } = useLocation();
  const ref = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (state !== null) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [state]);
  return (
    <>
      <section className="text-gray-600 body-font">
        <div className="container mx-auto flex flex-col px-5 py-24 justify-center items-center">
          <div className="w-full md:w-2/3 flex flex-col items-center text-center">
            <p className="text-md my-2 font-semibold text-088AB2 w-full">
              Our Events
            </p>
            <h1 className="title-font text-5xl mb-4 font-semibold text-101828">
              Events that Inspire
            </h1>
            <p className="mb-8 leading-relaxed text-lg text-667085">
              Propagation and inculcation of human values in each segment of
              society have always been the mission at Spandan.
              <br />
              <br />
              We believe that meaningful events can be vital as they can be
              successful in resonating emotions and values. Therefore, we
              organize inspiring events featuring esteemed speakers that align
              with our mission and vision.
            </p>
          </div>
        </div>
      </section>
      <section className="text-gray-600 body-font lg:mx-16">
        <div
          className="container px-5 pb-12 mb-12 mx-auto"
          id="events"
          ref={ref}
        >
          <p className="text-0E7090 font-semibold mb-5">Our Upcoming Events</p>
          <div className="h-1 bg-gray-200 rounded overflow-hidden">
            <div className="w-44 h-full bg-0E7090"></div>
          </div>
          <UpComingEvents />
          <div>
            <p className="text-0E7090 font-semibold mb-5">
              Our Previous Events
            </p>
            <div className="h-1 bg-gray-200 rounded overflow-hidden">
              <div className="w-44 h-full bg-0E7090"></div>
            </div>
          </div>

          <div className="flex flex-wrap mt-20">
            {webinars.map((webinar) => {
              return (
                <Events
                  key={webinar.id}
                  id={webinar.id}
                  featimage={webinar.featimage}
                  heading={webinar.heading}
                  featuring={webinar.featuring}
                  guest={webinar.guest}
                  past={webinar.past}
                  date={webinar.date}
                  time={webinar.time}
                  done={webinar.done}
                />
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default Homepage;
